<template>
  <div>
    <td class="moving text-center">
      <a
        @click="moveRowUp()"
        class="moveup"
        href="javascript:void(0)"
        title="W górę"
        tabindex="-1"
        v-if="moveUp"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
      <a
        @click="moveRowDown()"
        class="movedown"
        href="javascript:void(0)"
        title="W dół"
        tabindex="-1"
        v-if="moveDown"
      >
        <i class="fa fa-arrow-down"></i>
      </a>
      <a
        @click="removeRow($event)"
        class="delete"
        href="javascript:void(0)"
        title="Usiń"
        tabindex="-1"
        v-if="deleteRow"
      >
        <i class="fa fa-times"></i>
      </a>
      <!--
      <a
        @click.prevent="model.$clear()"
        class="delete"
        href="javascript:void(0)"
        title="Wyczyść"
        tabindex="-1"
        v-if="deleteRow"
      >
        <i class="fa fa-times"></i>
      </a>
      -->
    </td>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    deleteRow: {
      type: Boolean,
      default: true
    },
    moveUp: {
      type: Boolean,
      default: true
    },
    moveDown: {
      type: Boolean,
      default: true
    },
    confirmDeleteMessage: {
      type: String,
      default: 'Czy na pewno chcesz usunąć wiersz?'
    }
  },

  methods: {
    moveRowUp() {
      this.model.$moveUp();
      this.$emit('rowMovedUp', this.model);
    },
    moveRowDown() {
      this.model.$moveDown();
      this.$emit('rowMovedDown', this.model);
    },
    removeRow(event) {
      const removeRow = () => {
        this.model.$removeRow();
        this.$emit('rowDeleted');
      };

      if (this.formParent && this.formParent.$listeners['before-row-delete']) {
        return new Promise((resolve, reject) => {
          this.formParent.$emit('before-row-delete', event, this.confirmDeleteMessage, resolve);
        }).then(result => {
          if (result) {
            removeRow();
          }
        });
      } else {
        removeRow();
      }
    }
  },
  computed: {
    formParent: {
      get() {
        let parent = this.$parent;
        for (;;) {
          if (parent.form) {
            break;
          }

          if (parent.$parent) {
            parent = parent.$parent;
          }

          if (!parent.$parent) {
            parent = undefined;
            break;
          }
        }

        return parent;
      }
    }
  }
};
</script>

